import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_indices3txodfl5wuu5j as get_indices,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ImageRemote256pcav1ipbca as ImageRemote,
  ImageScaleType_Fit_getInstance3ce22z7h47ouq as ImageScaleType_Fit_getInstance,
} from '../../models/data.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../models/Theme.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../helpers.mjs';
import {
  ActivityIndicatork1oa7i2hevyv as ActivityIndicator,
  ActivityIndicator$_get_shown_$ref_61t2d12wpeiijqwosf5 as ActivityIndicator$_get_shown_$ref_61t2d1,
  ActivityIndicator$_set_shown_$ref_zcnirl1dri7v5nx6qpb as ActivityIndicator$_set_shown_$ref_zcnirl,
} from './ActivityIndicator.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../NativeElement.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './Frame.commonHtml.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref } from '../NativeElement.commonHtml.mjs';
import { get_areAnimationsEnabled315dhlyuxowng as get_areAnimationsEnabled } from '../Element.ext.js.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { RawImageView3rlp4gsc2bxt0 as RawImageView } from './RawImageView.commonHtml.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Element1y2xoj9fs2s4 as Element } from '../Element.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function showsSameAs($this, rendered, incoming) {
  if (rendered == null || incoming == null)
    return equals(rendered, incoming);
  var tmp;
  if (rendered.scaleType_1.equals(incoming.scaleType_1) && rendered.description_1 == incoming.description_1 && rendered.sources_1.get_size_woubt6_k$() === incoming.sources_1.get_size_woubt6_k$()) {
    var tmp0 = get_indices(rendered.sources_1);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = tmp0.first_1;
      var last = tmp0.last_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element;
          if (!showsSameAs_0(Companion_instance, rendered.sources_1.get_c1px32_k$(it), incoming.sources_1.get_c1px32_k$(it))) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  return tmp;
}
function showsSameAs_0($this, rendered, incoming) {
  var tmp;
  if (!(rendered instanceof ImageRemote())) {
    tmp = true;
  } else {
    tmp = !(incoming instanceof ImageRemote());
  }
  if (tmp)
    return equals(rendered, incoming);
  if (!rendered.cacheStrategy_1.equals(incoming.cacheStrategy_1))
    return false;
  var tmp_0;
  switch (rendered.cacheStrategy_1.ordinal_1) {
    case 0:
      tmp_0 = false;
      break;
    case 1:
      tmp_0 = rendered.url_1 === incoming.url_1;
      break;
    case 2:
      tmp_0 = substringBefore(rendered.url_1, _Char___init__impl__6a9atx(63)) === substringBefore(incoming.url_1, _Char___init__impl__6a9atx(63));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
}
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      constructor(sources, scaleType, description) {
        this.sources_1 = sources;
        this.scaleType_1 = scaleType;
        this.description_1 = description;
      }
      copy_at35jg_k$(sources, scaleType, description) {
        return new (Info())(sources, scaleType, description);
      }
      copy$default_n4fxd0_k$(sources, scaleType, description, $super) {
        sources = sources === VOID ? this.sources_1 : sources;
        scaleType = scaleType === VOID ? this.scaleType_1 : scaleType;
        description = description === VOID ? this.description_1 : description;
        return $super === VOID ? this.copy_at35jg_k$(sources, scaleType, description) : $super.copy_at35jg_k$.call(this, sources, scaleType, description);
      }
      toString() {
        return 'Info(sources=' + toString(this.sources_1) + ', scaleType=' + this.scaleType_1.toString() + ', description=' + this.description_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.sources_1);
        result = imul(result, 31) + this.scaleType_1.hashCode() | 0;
        result = imul(result, 31) + (this.description_1 == null ? 0 : getStringHashCode(this.description_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!equals(this.sources_1, other.sources_1))
          return false;
        if (!this.scaleType_1.equals(other.scaleType_1))
          return false;
        if (!(this.description_1 == other.description_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Info');
    InfoClass = $;
  }
  return InfoClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
function ImageView$refresh$slambda($milliseconds, this$0, $it) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    this$0.frame_1.removeChild_kofmvd_k$($it);
    return Unit_instance;
  }), 1);
}
var ImageView$refresh$$inlined$ThemeDerivation$1Class;
function ImageView$refresh$$inlined$ThemeDerivation$1() {
  if (ImageView$refresh$$inlined$ThemeDerivation$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      invoke_h6mny6_k$(theme) {
        return this.this$0__1.frame_1.themeAndBack_1.drawBackground_1 ? theme.withBack_1 : theme.withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    ImageView$refresh$$inlined$ThemeDerivation$1Class = $;
  }
  return ImageView$refresh$$inlined$ThemeDerivation$1Class;
}
function ImageView$refresh$lambda($$this$rawImage, $view, $info) {
  return ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this$reactive.state_a9mnra_k$($$this$rawImage.state_1);
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    var tmp;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp = Unit_instance;
    } else {
      if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
        tmp = Unit_instance;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          var it = _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
          if ($view.lastRendered_1 === $info) {
            var latestInfo = $view.info_1;
            if (!(latestInfo == null) && !equals(latestInfo, $info)) {
              $view.lastRendered_1 = null;
              $view.refresh_6a3uvf_k$();
            } else {
              $view._shownInfo_1.set_state_wnfcx0_k$(Companion_getInstance().exception_iibuh2_k$(it));
              $view.lastRendered_1 = null;
            }
          }
          tmp = Unit_instance;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
            $$this$rawImage.set_opacity_ecw914_k$(1.0);
            if ($view.lastRendered_1 === $info) {
              $view._shownInfo_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b($info));
            }
            tmp = Unit_instance;
          } else {
            _ReactiveState___get_raw__impl__92ipya(this_0);
            $$this$rawImage.set_opacity_ecw914_k$(1.0);
            if ($view.lastRendered_1 === $info) {
              $view._shownInfo_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b($info));
            }
            tmp = Unit_instance;
          }
        }
      }
    }
    return Unit_instance;
  };
}
var ImageViewClass;
function ImageView() {
  if (ImageViewClass === VOID) {
    class $ {
      constructor(frame) {
        return new.target.new_com_lightningkite_kiteui_views_direct_ImageView_47rt7g_k$(frame);
      }
      static new_com_lightningkite_kiteui_views_direct_ImageView_47rt7g_k$(frame) {
        var $this = createThis(this);
        $this.frame_1 = frame;
        $this.info_1 = null;
        $this._shownInfo_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(_ReactiveState___init__impl__fvdp9b(null));
        var tmp = $this;
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        var this_0 = get_centered($this.frame_1);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (ActivityIndicator())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        var $this$activityIndicator = element;
        // Inline function 'com.lightningkite.reactive.extensions.addAndRunStateListener' call
        var this_1 = $this.get_shownInfo_mr6jpm_k$();
        var listener = () => {
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.success' call
          var this_0 = this_1.get_state_wc71uu_k$();
          var tmp_0;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_1;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp_1 = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(this_0);
            tmp_0 = !(tmp_2 instanceof InternalReactiveThrownException());
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp = 0.0;
          } else {
            tmp = 1.0;
          }
          $this$activityIndicator.set_opacity_ecw914_k$(tmp);
          return Unit_instance;
        };
        var release = this_1.addListener_6y9mct_k$(listener);
        listener();
        // Inline function 'kotlin.also' call
        onRemove($this$activityIndicator, release);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        tmp.spinner_1 = element;
        var tmp_0 = $this;
        var tmp0 = $this.spinner_1;
        var tmp_1 = KMutableProperty0();
        var tmp_2 = ActivityIndicator$_get_shown_$ref_61t2d1(tmp0);
        tmp_0.showLoadingIndicator$delegate_1 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, ActivityIndicator$_set_shown_$ref_zcnirl(tmp0));
        $this.ready_1 = false;
        $this.lastRendered_1 = null;
        $this.lastRender_1 = null;
        return $this;
      }
      static new_com_lightningkite_kiteui_views_direct_ImageView_jbctb3_k$(context) {
        return this.new_com_lightningkite_kiteui_views_direct_ImageView_47rt7g_k$(new (Frame())(context));
      }
      set_info_qq27ep_k$(value) {
        this.info_1 = value;
        this.refresh_6a3uvf_k$();
      }
      set_source_96c0pv_k$(value) {
        var tmp0_safe_receiver = this.info_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.copy$default_n4fxd0_k$(listOfNotNull(value));
        this.set_info_qq27ep_k$(tmp1_elvis_lhs == null ? new (Info())(listOfNotNull(value), ImageScaleType_Fit_getInstance(), null) : tmp1_elvis_lhs);
      }
      get_source_jl0x7o_k$() {
        var tmp0_safe_receiver = this.info_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sources_1;
        return tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
      }
      get_shownInfo_mr6jpm_k$() {
        return this._shownInfo_1;
      }
      onStartup_vrxh3i_k$() {
        this.frame_1.onStartup_vrxh3i_k$();
        this.ready_1 = true;
        this.refresh_6a3uvf_k$();
      }
      refresh_6a3uvf_k$() {
        if (!this.ready_1)
          return Unit_instance;
        var info = this.info_1;
        if (showsSameAs(Companion_instance, this.lastRendered_1, info))
          return Unit_instance;
        var tmp0_safe_receiver = this.lastRender_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0_safe_receiver.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (get_areAnimationsEnabled(this)) {
              element.set_opacity_ecw914_k$(0.0);
              // Inline function 'com.lightningkite.kiteui.afterTimeout' call
              var milliseconds = _Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(element).transitionDuration_1);
              var job = launch(this, VOID, VOID, ImageView$refresh$slambda(milliseconds, this, element));
              Job$cancel$ref(job);
            } else {
              this.frame_1.removeChild_kofmvd_k$(element);
            }
          }
        }
        this.lastRendered_1 = info;
        if (info == null || info.sources_1.isEmpty_y1axqb_k$()) {
          this._shownInfo_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(null));
          this.spinner_1.set_opacity_ecw914_k$(0.0);
          this.lastRender_1 = null;
          return Unit_instance;
        }
        this._shownInfo_1.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
        var tmp$ret$3 = new (ImageView$refresh$$inlined$ThemeDerivation$1())(this);
        var writer = themed(this.frame_1, tmp$ret$3);
        var view = this;
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = info.sources_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp0_elvis_lhs = info.description_1;
          var tmp4 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
          var scaleType = info.scaleType_1;
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RawImageView())(writer.get_context_h02k06_k$(), item, tmp4, scaleType);
          ensureOutermostElement(element_0);
          writer.willAddChild_hz2iwc_k$(element_0);
          element_0.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
          element_0.set_opacity_ecw914_k$(0.0);
          reactive(element_0, VOID, ImageView$refresh$lambda(element_0, view, info));
          element_0.onStartup_vrxh3i_k$();
          writer.addChild_2qpft2_k$(element_0);
          destination.add_utx5q5_k$(element_0);
        }
        tmp.lastRender_1 = destination;
      }
      get_context_h02k06_k$() {
        return this.frame_1.get_context_h02k06_k$();
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.frame_1.get_underlyingNativeElement_vngz33_k$();
      }
      get_parent_hy4reb_k$() {
        return this.frame_1.get_parent_hy4reb_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.frame_1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.frame_1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.frame_1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.frame_1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.frame_1.get_visible_8zfvk9_k$();
      }
      set_paddingByEdge_53g79y_k$(_set____db54di) {
        this.frame_1.set_paddingByEdge_53g79y_k$(_set____db54di);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.frame_1.paddingByEdge_1;
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.frame_1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.frame_1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.frame_1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.frame_1.themeAndBack_1;
      }
      get_dragData_pas5on_k$() {
        return this.frame_1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.frame_1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.frame_1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.frame_1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.frame_1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.frame_1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.frame_1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.frame_1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.frame_1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.frame_1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.frame_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.frame_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'ImageView', VOID, VOID, [Element()]);
    ImageViewClass = $;
  }
  return ImageViewClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ImageView as ImageViewadm9fg4ms58f,
};
//endregion

//# sourceMappingURL=ImageView.mjs.map
